export default __webpack_public_path__ + "static/media/greeting3.9bed9bd5.png";